import React from 'react'
import common from '../../../assets/common.jpg'
import MegaNavbar from '../../../Components/MegaNavbar'
import DrambrinCv from '../../../assets/CVs/Botany/DrambrinCV.pdf'
import DrFaizaCv from '../../../assets/CVs/Botany/DrFaizaTawabCV.pdf'
import DrNailaCv from '../../../assets/CVs/Botany/NailaCv.pdf'
const Botany = () => {
  return (
    <>
       <MegaNavbar/>
    <section id="team" className="team section-bg">
        <div className="container">

      <div className="section-title">
        <h2>Botany</h2>
       
        <p>Faculty of Botany.</p>
      </div>

      <div className="row">


      {/* (1) Dr.  Faiza Tawab profile */}
      <div className="col-lg-6">
          <div className="member d-flex align-items-start">
            <div className="teampic"><img src={common} className="img-fluid" alt="" /></div>
            <div className="member-info">
              <h4>Dr. Faiza Tawab </h4>
              <span>Assistant Professor/ Head of Department Botany </span>
              
              <p>Head of Department Botany, Shaheed Benazir Bhutto Woman University Peshawar  </p>
              <p className='my-icon'><i className="bi bi-envelope-at-fill"></i> : drfaizatawab@sbbwu.edu.pk  </p>

              
              <div className="social">
                <a href={DrFaizaCv}><i class="bi bi-file-earmark-person-fill"></i></a>
                <a href=" https://scholar.google.com/citations?hl=en&user=ROMlGDQAAAAJ"><i className="bi bi-google"></i></a>
                 <a href=""><i className="bi bi-linkedin"></i></a>
                
              </div>
            </div>
          </div>
        </div>
 
      <div className="col-lg-6">
          <div className="member d-flex align-items-start">
            <div className="teampic"><img src={common} className="img-fluid" alt="" /></div>
            <div className="member-info">
              <h4>Dr. Amrin</h4>
              <span>Assistant Professor Department of Botany</span>
              <p>Assistant Professor Department
                 of Botany Shaheed Benazir Bhutto Women University Peshawar </p>
                 <p className='my-icon'><i className="bi bi-envelope-at-fill"></i> : ambrin.khan@sbbwu.edu.pk</p>
              <div className="social">
                <a href={DrambrinCv}><i class="bi bi-file-earmark-person-fill"></i></a>
                <a href=" https://scholar.google.com/citations?hl=en&user=ROMlGDQAAAAJ"><i className="bi bi-google"></i></a>

                <a href=""><i className="bi bi-linkedin"></i></a>
              </div>
            </div>
          </div>
        </div>
        




    

       {/* (3) Dr. Naila profile  */}


        <div className="col-lg-6">
          <div className="member d-flex align-items-start">
            <div className="teampic"><img src={common} className="img-fluid" alt="" /></div>
            <div className="member-info">
              <h4>Dr. Naila Inayat   </h4>
              <span>Assistant Professor Department of Botany  </span>
              
              <p> Assistant Professor Department
                 of Botany Shaheed Benazir Bhutto Women University Peshawar </p>
              <p className='my-icon'><i className="bi bi-envelope-at-fill"></i> : naila.inayat@sbbwu.edu.pk  </p>
               <div className="social">
                <a href={DrNailaCv}> <i class="bi bi-file-earmark-person-fill"></i></a>
                <a href=""><i className="bi bi-google"></i></a>
                <a href=""><i className="bi bi-linkedin"></i></a>
               
              </div>
            </div>
          </div>
        </div>

        {/* Repeat the above structure for other team members */}

      </div>

    </div>
  </section>
    </>
  )
}

export default Botany
   